import React, { useEffect } from "react";
import Switch from "react-switch";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Field, Form } from "formik";
import { useTranslation } from "react-i18next";
import { LocationsModal } from "./LocationsModal";
import { onAllRestorantsLoad, onTaxDelete, onTaxFieldClear, onTaxLoad, onTaxNewCreate } from "../../../store/Settings/actions";
import Loading from "../../../components/Loading";
import { TaxDeleteModal } from "./TaxDeleteModal";
import "../setting.css";

export const CreateTax = ({ setOpenCreateTax, setSelectedIndex, taxId, setTaxId }) => {
    const [data, setData] = useState({
        tax_name: "",
        tax_rate: "",
    })
    const [taxCalculationChecked, setChecked] = useState(false);
    const [taxEnableChecked, setTaxEnableChecked] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [locationChecked, setLocationChecked] = useState([]);
    const [selected, setSelected] = useState([]);
    const [checkChange, setCheckChange] = useState(true);

    const [isCheckAll, setIsCheckAll] = useState(false);
    const [isCheckAllFutureLocations, setIsCheckAllFutureLocations] =
        useState(false);

    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        if (taxId) {
            dispatch(onTaxLoad(taxId));
        }
        dispatch(onAllRestorantsLoad())
    }, [taxId]);

    const {loading, tax_name, tax_rate, is_included, is_enable, is_all_restaurants,
        all_future_locations, redirect, checked_restaurants, all_restaurants_list} = useSelector(({settings}) => ({
        loading: settings.loading,
        redirect: settings.redirect,
        tax_name: settings.tax.name,
        tax_rate: settings.tax.rate,
        is_included: settings.tax.is_included,
        is_enable: settings.tax.is_enable,
        is_all_restaurants: settings.tax.is_all_restaurants,
        all_future_locations: settings.tax.all_future_locations,
        checked_restaurants: settings.tax.restaurants,
        all_restaurants_list: settings.all_restaurants_list,
    }));

    const restId = checked_restaurants.map(item => item.id)
    const allRestaurants = all_restaurants_list.map(rest=>(
        {name: rest.name, id: rest.id, checked: restId.includes(rest.id)}))

    useEffect(()=>{
        if(all_restaurants_list) {
            setLocationChecked(allRestaurants)
        }
    }, [checked_restaurants, all_restaurants_list])

    useEffect(() => {
        redirect && (
            setOpenCreateTax((prev) => !prev),
            setTaxId(""));
    }, [redirect]);

    useEffect(() => {
        if (taxId) {
            setData((prevState) => ({
                ...prevState, tax_name, tax_rate}));
            setChecked(is_included);
            setTaxEnableChecked(is_enable);
            setIsCheckAll(is_all_restaurants);
            setIsCheckAllFutureLocations(all_future_locations);
            setSelected(checked_restaurants)
        }
    }, [tax_name, tax_rate, is_included, is_enable, is_all_restaurants,
        all_future_locations, checked_restaurants]);

    const deleteHandle = ()=>{
        dispatch(onTaxDelete(taxId))
        onCloseDeleteModal()
    }

    const cancelHandle = () => {
        setOpenCreateTax((prev) => !prev);
        dispatch(onTaxFieldClear())
        setTaxId("")
    };

    const onOpenModal = () => {
        setOpenModal((prev) => !prev);
        setCheckChange((prev) => !prev)
    };

    const onCloseModal = () => {
        setOpenModal((prev) => !prev);
        setCheckChange((prev) => !prev)
    };

    const onOpenDeleteModal = () => { setOpenDeleteModal((prev) => !prev)};
    const onCloseDeleteModal = () => { setOpenDeleteModal((prev) => !prev)};
    const onSaveLocations = () => { onCloseModal()};

    const onChangeLocations = (name) => {
        const newLoaction = locationChecked.map((item) =>
            item.name === name
                ? { ...item, checked: !item.checked }
                : { ...item }
        );

        setLocationChecked(newLoaction);
        const checkedArr = newLoaction.filter(({ checked }) => checked);

        if (checkedArr.length === locationChecked.length) {
            setIsCheckAll(true);
        } else {
            setIsCheckAll(false);
        }

        setSelected(checkedArr);
    };

    const handleSelectAll = () => {
        setIsCheckAll(!isCheckAll);
        const allLoaction = locationChecked.map((item) => ({
            ...item,
            checked: true,
        }));
        setLocationChecked(allLoaction);
        setSelected(allLoaction);

        if (isCheckAll) {
            const notLoaction = locationChecked.map((item) => ({
                ...item,
                checked: false,
            }));
            setLocationChecked(notLoaction);
            setSelected([]);
        }
    };

    const handleSelectAllFutureLocations = () => {
        setIsCheckAllFutureLocations(!isCheckAllFutureLocations);
    };

    const selectedIds = selected.map(item=>item.id)

    let buttonName1 = isCheckAll
        ? "All Locations"
        : selected.map(({ name }) => (
              <span className="mr-2" key={name}>
                  {name}
              </span>
          ));

    let buttonName2 = isCheckAllFutureLocations ? "All Future Locations" : null;

    return (
        <Loading loading={loading}>
            <Formik
                enableReinitialize
                initialValues={data}
                onSubmit={async (values) => {
                    dispatch(onTaxNewCreate(
                        taxId? taxId : null, values, taxCalculationChecked ? 1 : 0, isCheckAll ? 1 : 0,
                        taxEnableChecked ? 1 : 0, selectedIds, isCheckAllFutureLocations ? 1 : 0));
                    setSelectedIndex(3)
                }}
            >
            <Form>
                <div className="grid grid-cols-1 mt-3">
                    <div className="flex justify-between items-center">
                        <p className="font-extrabold text-3xl mt-8 mb-6 mr-6 whitespace-nowrap">
                            {taxId? t("Edit Tax") : t("Create Tax")}
                        </p>

                        {taxId && !taxEnableChecked &&
                            <p className="text-xs font-medium bg-purple-50 py-2 text-center px-7 rounded-md">
                                {t("This tax is disabled and will not apply to any items or purchases. Re-enable using this toggle")}
                            </p>}

                        <div className="flex justify-between items-center ml-6">
                            <div>
                                {taxId && (
                                    <button
                                        type="button"
                                        className="inline-flex justify-center mr-1 py-2 px-7 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-red-500 hover:bg-red-300 focus:outline-none"
                                        onClick={onOpenDeleteModal}
                                    >
                                        {t("Delete")}
                                    </button>)}
                                    <TaxDeleteModal
                                        visible={openDeleteModal}
                                        onClose={onCloseDeleteModal}
                                        onDelete={deleteHandle}
                                    />
                            </div>

                            <div className="py-3 text-right flex flex-nowrap">
                                <button
                                    type="button"
                                    className="inline-flex justify-center mr-1 py-2 px-7 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-300 hover:bg-gray-400 activ:bg-gray-500 focus:outline-none"
                                    onClick={cancelHandle}
                                >
                                    {t("Cancel")}
                                </button>
                                <button
                                    type="submit"
                                    className="inline-flex justify-center py-2 px-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                                >
                                    {t("Save")}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="rounded-lg shadow-md bg-white pt-11 pb-4 px-12">
                        <p className="font-bold text-xl">
                            {t("Details")}
                        </p>

                        <div className="col-span-3 sm:col-span-3 py-3.5">
                            <label
                                htmlFor="tax_name"
                                className="block text-sm font-semibold"
                            >
                                {t("Tax name")}
                            </label>
                            <Field
                                type="text"
                                name="tax_name"
                                placeholder={t("VAT")}
                                className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                            />
                        </div>

                        <div className="col-span-3 sm:col-span-3 py-3.5">
                            <label
                                htmlFor="tax_rate"
                                className="block text-sm font-semibold"
                            >
                                {t("Tax rate")}
                            </label>
                            <Field
                                type="text"
                                name="tax_rate"
                                className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                            />
                        </div>

                        <div className="col-span-3 sm:col-span-3 py-3.5">
                            <p className="block text-sm font-semibold">
                                {t("Locations")}
                            </p>

                            <button
                                onClick={onOpenModal}
                                type="button"
                                className="mt-1 border-none text-blue-600 text-left px-2 focus:ring-gray-200 h-9 focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                            >
                                {checkChange ? (
                                    <>
                                        <span className="mr-1.5">
                                            {selected && buttonName1}
                                        </span>
                                        <span className="mr-1.5">
                                            {isCheckAllFutureLocations && buttonName2}
                                        </span>
                                    </>
                                ) : ""}
                            </button>

                            <LocationsModal
                                visible={openModal}
                                onClose={onCloseModal}
                                onChangeLocations={onChangeLocations}
                                onSave={onSaveLocations}
                                locations={locationChecked}
                                handleSelectAll={handleSelectAll}
                                handleSelectAllFutureLocations={
                                    handleSelectAllFutureLocations
                                }
                                isCheckAll={isCheckAll}
                                isCheckAllFutureLocations={
                                    isCheckAllFutureLocations
                                }
                            />
                        </div>

                        <div className="col-span-3 sm:col-span-3 pt-12">
                            <p className="block text-sm font-semibold">
                                {t("Tax Calculation")}
                            </p>
                            <div className="flex items-center input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 w-full shadow-sm sm:text-sm rounded-md px-5 py-3.5">
                                <Switch
                                    onChange={() => setChecked((prev) => !prev)}
                                    checked={taxCalculationChecked ?? false}
                                    height={20}
                                    width={44}
                                    id="included_switsh"
                                    onColor="#7f56d9"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                />
                                <label htmlFor="included_switsh" className="mx-7">
                                    <p className="block text-sm font-semibold mb-1.5 cursor-pointer">
                                        {t("Include tax in item price")}
                                    </p>
                                    <p className="block text-xs font-normal">
                                        {t(
                                            "If tax is included, your customers will not see the tax on their receipt"
                                        )}
                                    </p>
                                </label>
                            </div>
                        </div>

                        <div className="col-span-3 sm:col-span-3 pt-3.5 pb-3.5">
                            <p className="block text-sm font-semibold">
                                {t("Status")}
                            </p>
                            <div className="flex items-center input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 w-full shadow-sm sm:text-sm rounded-md px-5 py-3.5">
                                <Switch
                                    onChange={() => setTaxEnableChecked((prev) => !prev)}
                                    checked={taxEnableChecked ?? false}
                                    height={20}
                                    width={44}
                                    id="enable_switsh"
                                    onColor="#7f56d9"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                />
                                <label htmlFor="enable_switsh" className="mx-7">
                                    <p className="block text-sm font-semibold mb-1.5 cursor-pointer">
                                        {t("Enable")}
                                    </p>
                                    <p className="block text-xs font-normal">
                                        {t("Enable this tax to items and purchases")}
                                    </p>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
            </Formik>
        </Loading>

    );
};
